import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectStore } from '@store/selectors';
import { switchMap, take, tap } from 'rxjs/operators';
import { CustomerVaultPayload, PayCustomerData, PaymentResponseData, Store as StoreModel } from '@core/models';
import { environment } from '@environments/environment';
import { IResponseObjectSuccess, IResponseSuccess } from '@core/interfaces';

@Injectable({
	providedIn: 'root',
})
export class PayService {
	private store$: Observable<StoreModel | null>;

	constructor(
		private http: HttpClient,
		private store: Store
	) {
		this.store$ = this.store.select(selectStore);
	}

	getToken(): Observable<{ token: string }> {
		return this.http.post<{ token: string }>(
			`${environment.microIntegrationMerchantMx}/auth/get-token`,
			{},
			{
				headers: {
					accept: 'application/json',
				},
			}
		);
	}

	processPayment(
		vaultedCardToken: string,
		amount: number,
		localId: string,
		diaLaboralId: string,
		isGuest: boolean = false
	): Observable<IResponseObjectSuccess<PaymentResponseData>> {
		return this.store$.pipe(
			take(1),
			switchMap(storeData => {
				if (!storeData?.apiKey) {
					throw new Error('API key not available');
				}

				const paymentData = {
					vaultedCardToken,
					guest: isGuest,
					amount,
					localId,
					diaLaboralId,
				};

				return this.http
					.post<IResponseObjectSuccess<PaymentResponseData>>(
						`${environment.microIntegrationMerchantMx}/payment`,
						paymentData,
						{
							headers: {
								accept: 'application/json',
								'Content-Type': 'application/json',
								authorization: storeData.apiKey,
							},
						}
					)
					.pipe(
						tap({
							error: err => {},
						})
					);
			})
		);
	}

	createCustomerLogged(customerData: CustomerVaultPayload): Observable<IResponseSuccess<PayCustomerData>> {
		return this.store$.pipe(
			take(1),
			switchMap(storeData => {
				if (!storeData?.apiKey) {
					throw new Error('API key not available');
				}

				return this.http.post<IResponseSuccess<PayCustomerData>>(
					`${environment.microIntegrationMerchantMx}/customer`,
					customerData,
					{
						headers: {
							accept: 'application/json',
							'Content-Type': 'application/json',
							Authorization: storeData.apiKey,
						},
					}
				);
			})
		);
	}
}
